import { getLocalStorage } from '@r-client/shared/util/core';

import { log } from '../log';

/**
 * Our own copy of Osano's last ANALYTICS answer, readable before Osano loads.
 * Overwritten on every Osano report. See ADR 20261015, "Privacy position".
 */
const STORAGE_KEY = 'rum:analytics-consent';

const GRANTED = 'granted';
const DENIED = 'denied';

/**
 * `undefined` means no answer was ever saved — first visit, cleared storage, or
 * storage blocked — and must not be read as a refusal.
 */
export const readCachedAnalyticsConsent = (): boolean | undefined => {
  try {
    const value = getLocalStorage()?.getItem(STORAGE_KEY);

    if (value === GRANTED) {
      return true;
    }
    if (value === DENIED) {
      return false;
    }
    return undefined;
  } catch (error) {
    // Accessing storage throws when site data is blocked.
    log('consent cache read failed %o', error);
    return undefined;
  }
};

export const writeCachedAnalyticsConsent = (isGranted: boolean): void => {
  try {
    getLocalStorage()?.setItem(STORAGE_KEY, isGranted ? GRANTED : DENIED);
  } catch (error) {
    // Quota exceeded or storage blocked. The in-session switch still applies;
    // only the next page load loses the head start.
    log('consent cache write failed %o', error);
  }
};
